import { ChainId } from "src/constants"

const LEGACY_USDC = "0xc21223249ca28397b4b6541dffaecc539bff0c59"

type TokenLike = {
  addresses?: Record<number, string>
  address?: string
  symbol?: string
  name?: string
}

const isLegacyUsdc = (t?: TokenLike): boolean => {
  if (!t) return false
  // Token objects carry the full addresses map — match by Cronos mainnet address
  if (t.addresses?.[ChainId.MAINNET]) {
    return t.addresses[ChainId.MAINNET].toLowerCase() === LEGACY_USDC
  }
  // TokenOption objects carry a single resolved address — accept it as a fallback
  if (t.address) {
    return t.address.toLowerCase() === LEGACY_USDC
  }
  // Strictly address-based: a token carrying neither address form is never treated
  // as legacy USDC. Callers must thread the address through (see Deposit.tsx).
  return false
}

export const getTokenDisplaySymbol = (t?: TokenLike): string =>
  isLegacyUsdc(t) ? "USDC.e" : t?.symbol ?? ""

export const getTokenDisplayName = (t?: TokenLike): string =>
  isLegacyUsdc(t) ? "Bridged USDC (Cronos)" : t?.name ?? ""
